<script setup>
import Layout from "../Layouts/Customer.vue";
import {useToast} from "primevue/usetoast";
import Message from "primevue/message";
import Button from "primevue/button";
import {useForm} from "@inertiajs/inertia-vue3";
import {computed, ref} from "vue";


const props = defineProps([
    'customer',
    'menuItems',
    'flash',
    'isUpdateNeeded',
]);

const toast = useToast();
const hasAiPlan = ref(Boolean(props.customer.ai_plan))
const aiPlan = ref(props.customer.ai_plan)

const form = useForm({
    'customer_id': props.customer.id
})

const updateForm = useForm({

})

const requestAi = () => {
    form.post('/ai-plans', {
        preserveState: false,

        onSuccess: () => {
            toast.add({
                severity: "success",
                summary: "Aktualisiert",
                life: 5000,
            });
        }
    });
}

const updateAiPlan = () => {
    updateForm.post(`/ai-plans/${aiPlan.value.uuid}`, {
        preserveState: false,

        onSuccess: () => {
            toast.add({
                severity: "success",
                summary: "Aktualisiert",
                life: 5000,
            });
        }
    });
}

const plan = computed(() => {
    if (! hasAiPlan.value) {
        return ''
    }

    var breakTag = '<br>';
    var replaceStr = '$1'+ breakTag;

    return (aiPlan.value.plan + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
})

const download = () => {
    window.location.href = `/customers/${props.customer.uuid}/ai-plan/export`
}

</script>
<template>
    <Layout :customer="customer" :menu-items="menuItems" :flash="flash">
        <div class="py-7 text-sm">
            <div class="px-14">
                <div class="flex justify-end">
                    <i v-if="hasAiPlan"
                       class="pi pi-file-pdf text-[#C5C6CC] cursor-pointer"
                       @click="download"></i>
                </div>

                <Message v-if="! hasAiPlan"
                         severity="warn"
                         :closable="false">
                    <div class="flex justify-between items-center">
                        <span>Sie haben noch keinen AI-Plan.</span>

                        <Button
                            label="Anfrage"
                            :loading="form.processing"
                            :disabled="form.processing"
                            @click="requestAi"
                            class="min-w-[100px] !bg-black !text-[#FFF053] !border-none"
                        />
                    </div>
                </Message>

                <Message v-if="isUpdateNeeded"
                         severity="warn"
                         :closable="false">
                    <div class="flex justify-between items-center">
                        <span>Ihre Anamnese wurde aktualisiert.</span>

                        <Button
                            label="Anfrage"
                            :loading="updateForm.processing"
                            :disabled="updateForm.processing"
                            @click="updateAiPlan"
                            class="min-w-[100px] !bg-black !text-[#FFF053] !border-none"
                        />

                    </div>
                </Message>

                <div v-html="plan" class="text-base">
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
:deep(.p-message-wrapper .p-message-text) {
    width: 100%;
}
</style>
